import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import {Subscription} from 'rxjs/Subscription';
import { Router, ActivatedRoute } from '@angular/router';

import { RequestsServices } from '../../../services/requests.service';
import { UserService } from '../../../services/user.service';
import { StorageService } from '../../../services/storage.service';
import { PageBase } from '../../../page.base';
import { ToasterService } from '../../../services/toaster.service';
import { TranslateService } from '@ngx-translate/core';
import { IAccount } from '../../../interfaces/account';
import { AuthService } from '../../../services/auth.service';
import { select, Store } from '@ngrx/store';
import { getUser, getActiveBusiness, isLogged } from '../../../store/selectors/auth.selectors';
import { updateUser } from '../../../store/actions/auth.actions';
import { TrialToasterService } from '../../../services/trial-toaster.service';
import { Observable } from 'rxjs/Observable';

@Component({
  selector: 'app-profile-edit',
  templateUrl: './profile-edit.component.html',
  providers: [ RequestsServices, StorageService, UserService ],
  encapsulation: ViewEncapsulation.None
})

export class ProfileEditComponent extends PageBase implements OnInit {

  private routeParamsSubscription: Subscription;
  public cpf: string;
  public accountPassword = {
    password: '',
    password_new: '',
    password_new_confirmation: ''
  };

  public isLoading = false;
  private isEdit = false;
  private establishmentId;
  private companyId;
  public typeBusiness;

  public account: any = {
    id: null,
    first_name: '',
    surname: '',
    email: '',
    cpf: '',
    profilesId: null,
    emailPersonal: '',
    gender: '',
    hasChilds: '',
    phone: '',
    birthDate: '',
    cep: '',
    jobPosition: '',
    employeeRegistrationNumber: '',
  };

  isLoggedIn$: Observable<boolean>;
  public inputErrors;
  public accountToUpdate: IAccount = <IAccount>{};
  public storePreviosEmail: String = null;
  public activeBusiness: any;
  private userLevel: string;
  public loggedAccount;
  public typeCompany = false;
  public showReport = false;
  public typeEstab = false;
  public typeCollaborator = false;

  private TRIAL = 'trial';
  private EMPLOYEE = 'employee';
  private ROLE_COMPANY = 'company';
  private ROLE_ESTAB = 'establishment';

  constructor(
    private translate: TranslateService,
    private toasterService: ToasterService,
    private request: RequestsServices,
    private route: ActivatedRoute,
    private router: Router,
    private storage: StorageService,
    private userService: UserService,
    private authService: AuthService,
    private store: Store
  ) {
    super();

    let languageCurrent = navigator.language;
    translate.addLangs(['en', 'pt-br']);
    translate.setDefaultLang('en');
    languageCurrent === 'pt-BR' ? translate.use('pt-br') : translate.use('en');

    const user = this.userService.getLoggedUser();
    const loggedAccount = this.userService.getLoggedAccount();
    this.typeBusiness = this.userService.getTypeAccount();

    if (this.typeBusiness === 'company') {
      this.companyId = loggedAccount['id'];
    } else if (this.typeBusiness === 'establishment') {
      this.establishmentId = loggedAccount['id'];
    } else {
      alert('Falha ao recuperar dados.');
    }

  }

  public ngOnInit(): void {
    window.scrollTo(0, 0);
    this.isLoggedIn$ = this.store.pipe(select(isLogged));
    this.store.pipe(select(getUser)).subscribe(user => this.loggedAccount = user);
    this.store.pipe(select(getActiveBusiness)).subscribe(activeBusiness => {
      this.activeBusiness = activeBusiness;
    });
    this.setUserActive();
    this.verifyTrialCompany();
    this.store.pipe(select(getUser)).subscribe(user => {
      this.account = user;
      this.setAccount();
    });
  }

  public changeToUpdateAccount(item, propertie) {
    this.accountToUpdate[propertie] = item.target.value;
  }

  private setAccount(): void {
    this.storePreviosEmail = this.account.email;
    this.cpf = this.account.cpf;
    this.transformObjectFromAPI();
    this.formatBirthDate();
  }

  private formatBirthDate(): void {
    // Remove the time from birthDate
    if (this.account && this.account.birthDate) {
      const birthDate = this.account.birthDate;
      const birthDateArray = birthDate.split('T');
      this.account.birthDate = birthDateArray[0];
    }
  }

  public getTypeBusiness(): string {
    return this.typeBusiness;
  }

  public updateAccount(): void {
    if (!this.validateModelFields()) {
      return;
    }

    if (this.accountToUpdate && this.accountToUpdate.email === this.storePreviosEmail) {
      delete this.accountToUpdate.email;
    }

    this.isLoading = true;
    this.authService.updateMe(this.accountToUpdate).subscribe(user => {
      this.account = user;
      this.isLoading = false;
      this.toasterService.info('Sucesso!', 'Cadastro atualizado com sucesso.', true, 4000);
      this.store.dispatch(updateUser({ user }));
      this.userService.requestAccountConfig();
    }, (err) => {
      this.isLoading = false;

      if (err.error.success === false && err.error.message === 'Error! CPF and Email are being used by different customers.') {
        this.toasterService.info('Atenção!', 'CPF e Email já estão sendo usados por dois usuários distintos. Entre em contato com nosso suporte em suporte@allya.com.br', false, 4000);
      } else if (err.error.message === "Email already exists") {
        this.toasterService.info('Atenção!', 'Email já cadastrado por outro usuário', false, 4000);
      } else {
        this.toasterService.info('Atenção!', 'Alguns campos possuem erros.', false, 4000);
      }

      this.displayValidationErrors(err);
    });
  }

  public updatePassword(): void {
    if (!this.validatePassowordFields()) {
      return;
    }

    this.isLoading = true;
    this.request.put('customers', this.accountPassword, '', '/me/password').then((passwordUpdated) => {
      this.isLoading = false;
      this.toasterService.info('Sucesso!', 'Senha atualizada com sucesso.', true, 4000);
    }, (err) => {
      this.isLoading = false;

      const errorAsObj = JSON.parse(err['_body']);

      if (errorAsObj.error.statusCode === 400 && errorAsObj.error.code === 'INVALID_PASSWORD') {
        this.toasterService.info('Atenção!', 'Senha antiga incorreta', false, 4000);
      } else {
        this.toasterService.info('Atenção!', 'Alguns campos possuem erros.', false, 4000);
      }

    });
  }

  private transformObjectFromAPI(): void {
    const data = {
      first_name: this.account.first_name.trim(),
      surname: this.account.surname.trim(),
      hasChilds: this.account.hasChilds === true ? '1' : '0',
      emailPersonal: this.account.emailPersonal || this.account.personalEmail || this.account.email_personal || '',
    };

    this.account = {...this.account, ...data};
  }

  private validatePassowordFields(): boolean {
    if (!this.accountPassword.password) {
      this.toasterService.info('Atenção!', 'Senha deve ser preenchida.', true, 2000);
      return false;
    }

    if (!this.accountPassword.password_new) {
      this.toasterService.info('Atenção!', 'Nova senha deve ser preenchida.', true, 2000);
      return false;
    }

    if (!this.accountPassword.password_new_confirmation) {
      this.toasterService.info('Atenção!', 'Confirmação da nova senha deve ser preenchida.', true, 2000);
      return false;
    }

    if (this.accountPassword.password_new_confirmation !== this.accountPassword.password_new) {
      this.toasterService.info('Atenção!', 'Senha e confirmação de senha não conferem.', true, 2000);
      return false;
    }

    return true;
  }

  private validateModelFields(): boolean {
    if (!this.account.first_name) {
      this.toasterService.info('Atenção!', 'Nome deve ser preenchido.', true, 2000);
      return false;
    }

    if (!this.account.surname) {
      this.toasterService.info('Atenção!', 'Sobrenome deve ser preenchido.', true, 2000);
      return false;
    }

    if (!this.account.email) {
      this.toasterService.info('Atenção!', 'Email deve ser preenchido.', true, 4000);
      return false;
    }

    if (!this.account.cpf) {
      this.toasterService.info('Atenção!', 'CPF deve ser preenchidos.', true, 4000);
      return false;
    }

    if (this.account.cpf && !this.checkCPF(this.account.cpf)) {
      this.toasterService.info('Atenção!', 'CPF inválido.', true, 4000);
      return false;
    }

    if (this.account.email && !this.checkEmail(this.account.email)) {
      this.toasterService.info('Atenção!', 'Email inválido.', true, 4000);
      return false;
    }

    if (this.account.emailPersonal && !this.checkEmail(this.account.emailPersonal)) {
      this.toasterService.info('Atenção!', 'Email pessoal inválido.', true, 4000);
      return false;
    }

    return true;
  }

  private displayValidationErrors(response: any): void {
    if (response.status === 422) {
      window.scrollTo(0, 0);

      // Validations errors
      const errorsObject = JSON.parse(response._body);
      const errors = errorsObject.data.errors;
      let validationErrors;

      if (errors.length > 0) {
        validationErrors = errors[0].errors.messages;
      }

      this.inputErrors = validationErrors;
    }
  }

  public hasError(inputName): boolean {
    return this.inputErrors && inputName in this.inputErrors && this.inputErrors[inputName].length > 0;
  }

  public getError(inputName): string {
    if (this.inputErrors && inputName in this.inputErrors && this.inputErrors[inputName].length > 0) {
      return this.inputErrors[inputName][0];
    }
    return '';
  }

  verifyTrialCompany() {
    if (!this.activeBusiness || this.userLevel === this.EMPLOYEE) {
      return;
    }

    const { trial, customer_profile } = this.activeBusiness;
    if (customer_profile !== this.TRIAL) {
      return;
    }

    const trialEndPeriodGreaterThanToday = this.checkGreaterThanToday(trial.end_date_trial);
    if (!trialEndPeriodGreaterThanToday) {
      return;
    }
  }

  setUserActive(): void {
    // Get data from active account to send to intercom
    this.userService.updateIntercomUser();
    this.userLevel = this.userService.getUserLevel();
    const activeAccount = this.userService.getLoggedAccount();

      switch (this.loggedAccount['typeBusiness']) {

        // COMPANY
        case this.ROLE_COMPANY:

          this.typeEstab = false;
          this.showReport = this.userLevel === 'master' || this.userLevel === 'finance';

          if (this.userLevel === 'employee') {
            this.typeCollaborator = true;
            this.typeCompany = false;
          } else {
            this.typeCompany = true;
            this.typeCollaborator = false;
          }

          break;

        // ESTABLISHMENT
        case this.ROLE_ESTAB:
          this.typeEstab = true;
          this.typeCollaborator = false;
          this.typeCompany = false;
          this.showReport = false;

          break;

        default:
          break;
      }
    }
  }
